import AssessmentIcon from '@mui/icons-material/Assessment';
import EngineeringIcon from '@mui/icons-material/Engineering';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import ListAltIcon from '@mui/icons-material/ListAlt';
import NoFoodIcon from '@mui/icons-material/NoFood';
import StoreIcon from '@mui/icons-material/Store';
import SyncIcon from '@mui/icons-material/Sync';
import TableViewIcon from '@mui/icons-material/TableView';
import TaskIcon from '@mui/icons-material/Task';

import RoutesConstant from './routes';

const NavigationListConstant = [
  {
    label: 'Admin',
    icon: EngineeringIcon,
    isSelected: false,
    link: RoutesConstant.ADMIN,
  },
  {
    label: 'Orders',
    icon: FastfoodIcon,
    isSelected: false,
    subArray: [
      {
        label: 'Failed Orders',
        icon: NoFoodIcon,
        isSelected: false,
        link: RoutesConstant.FAILED_ORDERS,
      },
      {
        label: 'Failure Report',
        icon: AssessmentIcon,
        isSelected: false,
        link: RoutesConstant.FAILED_ORDER_REPORT,
      },
    ],
  },

  {
    label: 'Operations',
    icon: ListAltIcon,
    isSelected: false,
    subArray: [
      {
        label: 'Raw',
        link: RoutesConstant.OPS_RAW,
        icon: TaskIcon,
        isSelected: false,
      },
      {
        label: 'Consolidated',
        link: RoutesConstant.OPS_CONSOLIDATED,
        icon: TableViewIcon,
        isSelected: false,
      },
      {
        label: 'Report',
        link: RoutesConstant.OPS_REPORT,
        icon: AssessmentIcon,
        isSelected: false,
      },
    ],
  },
  {
    label: 'Outlets',
    icon: StoreIcon,
    isSelected: false,
    subArray: [
      {
        label: 'Outlets Mapping',
        link: RoutesConstant.OUTLETS,
        icon: FactCheckIcon,
        isSelected: false,
      },
      {
        label: 'Bulk Status Sync',
        link: RoutesConstant.BULK_OUTLET_SYNC,
        icon: SyncIcon,
        isSelected: false,
      },
    ],
  },
];

export default NavigationListConstant;
